import { render } from "./SurveyPlusStep.vue?vue&type=template&id=50b094ba&ts=true"
import script from "./SurveyPlusStep.vue?vue&type=script&lang=ts"
export * from "./SurveyPlusStep.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__